<script>
  /**
    Generates an SVG column chart. It uses the z-scale for color assignments and aassumes both `xScale` and `zScale` are ordinal scales.  It assumes your data is in a [D3 stack format](https://github.com/d3/d3-shape#stack
  */
  import { getContext } from "svelte";
  export let currentItem;

  const { data, xGet, yGet, zGet, xScale } = getContext("LayerCake");

  $: columnHeight = (d) => {
    const yVals = $yGet(d);
    return yVals[0] - yVals[1];
  };
</script>

<g class="column-group">
  {#each $data as series, i}
    {#each series as d, j}
      <rect
        class="group-rect"
        data-id={i}
        on:mousemove={(e) => {
          currentItem = {
            i,
            j,
            x: $xGet(d) + $xScale.bandwidth() / 4,
            y: e.pageY - 50,
          };
        }}
        x={$xGet(d) + $xScale.bandwidth() / 4}
        y={$yGet(d)[1]}
        width={$xScale.bandwidth() / 2}
        height={columnHeight(d)}
        fill={$zGet(series)}
      />
    {/each}
  {/each}
</g>
